import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ProductStatusDirective } from './directives/product-status.directive';
import { ProductIntegrationStatus } from '../../../enums';

@Component({
  selector: 'aionz-product-status',
  standalone: true,
  imports: [MatIconModule, ProductStatusDirective],
  templateUrl: './product-status.component.html',
  styleUrl: './product-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductStatusComponent {
  public status = input.required<ProductIntegrationStatus>();

  /** O item não foi integrado, mas nem sempre por falha nossa (o ERP recusou, falta cadastro…): por isso "Não completado". */
  protected readonly label = computed(() =>
    this.status() === ProductIntegrationStatus.INTEGRATION_FAILED ? 'Não completado' : this.status()
  );
}
